export const RECORDING_STATUS = {
    COMPLETED: 'COMPLETED',
    COMPLETED_WITH_ISSUES: 'COMPLETED_WITH_ISSUES',
    PENDING: 'PENDING',
};
